import { PageBody } from '../../../elements/page-body';
import { Dashboard2 } from '../../../pages/dashboard2';
import { HomeBody } from './home-body';

export const Home = () => {
    console.log('Home');
    return (
        <PageBody>
            <Dashboard2 />
        </PageBody>
    );
};

